import { useAppStore } from "@hooks/useAppStore";
import EmailForm from "@memorang/ui/components/Auth/EmailForm";
/* -----------------Child components--------------- */
import AuthContainer from "@memorang/ui/components/AuthContainer";

interface Props {
	handleSubmit: (email: string, password?: string) => void;
	loading?: boolean;
	emailFromUrl?: string;
	lastLoggedInEmail?: string;
	tos?: string;
	privacy?: string;
	showPasswordField?: boolean;
	onChangeEmail?: (email: string) => void;
}
const EmailView = ({
	handleSubmit,
	loading,
	emailFromUrl,
	lastLoggedInEmail,
	tos,
	privacy,
	showPasswordField,
	onChangeEmail,
}: Props) => {
	const appFont = useAppStore((state) => state.app.font) || "opensans";
	return (
		<>
			<AuthContainer>
				<EmailForm
					loading={loading}
					handleSubmitEmail={handleSubmit}
					emailFromUrl={emailFromUrl}
					lastLoggedInEmail={lastLoggedInEmail}
					tos={tos}
					privacy={privacy}
					showPasswordField={showPasswordField}
					onChangeEmail={onChangeEmail}
					appFont={appFont}
				/>
			</AuthContainer>
		</>
	);
};

export default EmailView;
